import navigation from '../modules/navigation';
import tracking from '../modules/tracking';
import header from '../modules/header';
import toTop from '../modules/toTop';
import videoElement from '../modules/videoElement';
import slider from '../modules/slider';
import toggle from '../modules/toggle';
import jumpToElement from '../modules/jumpToElement';
import cart from '../modules/cart';
import cookieBar from '../modules/cookieBar';
import embedWrap from '../modules/embedWrap';
import whatsapp from '../modules/whatsapp';
import alert from '../modules/alert';
import accessibility from '../modules/accessibility';
import eelInformation from '../modules/eelInformation';
import autoOpenModal from '../modules/autoOpenModal';

const general = () => {
  navigation.initialize();
  tracking.initialize();
  accessibility.initialize();
  header.initialize();
  toTop.initialize();
  videoElement.initialize();
  slider.initialize();
  toggle.initialize();
  jumpToElement.initialize();
  cart.initialize();
  cookieBar.initialize();
  embedWrap();
  whatsapp.initialize();
  alert.initialize();
  eelInformation.initialize();
  autoOpenModal.initialize();

  const modals = document.querySelectorAll('.modal');
  const modalsArray = Array.prototype.slice.call(modals);

  modalsArray.forEach((modal) => {
    if (modal.getAttribute('aria-hidden') === 'false') {
      const $modal = $(modal);
      $modal.modal('show');
    }
  });
};

export default general;
